/** @jsxImportSource @emotion/react */

import { ExclamationCircleOutlined, SearchOutlined } from '@ant-design/icons'
import { Card, Col, Form, Select, Input, Row, Typography, Button, Space, Table, Modal, Tag, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Spacer from '../../components/layout/Spacer'
import ProductCategoryFormModal from '../../components/product/ProductCategoryFormModal'
import productCategoryAPI from '../../services/productCategoryAPI'
import { utcToLocal } from '../../utils/helper'
import { INITIAL_PAGINATION } from '../../utils/constant'

function ProductCategoryPage() {
  const tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (value) => <b>{value}</b>
    },

    {
      title: 'Status',
      dataIndex: 'deletedAt',
      key: 'deletedAt',
      render: (val) => val ? <Tag color='red'>Inactive</Tag> : <Tag color='green'>Active</Tag>
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value) => <span>{utcToLocal(value)}</span>
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (value, record) => <Space >
        <Button type='link' size='small' onClick={() => selectData(record)}>Edit</Button>
        <Button type='link' size='small' onClick={() => deleteConfirm(value)}>Delete</Button>
      </Space >
    },
  ];

  const [modal, setModal] = useState(false)
  const [loading, setloading] = useState(false)
  const routeParams = useParams()

  const [productCategory, setProductCategory] = useState({
    data: [],
    selected: null,
  })

  const [pagination, setPagination] = useState(INITIAL_PAGINATION)

  useEffect(() => {
    fetchData(INITIAL_PAGINATION)
    setPagination(INITIAL_PAGINATION)
  }, [])

  const selectData = (record) => {
    setProductCategory({ ...productCategory, selected: record })
    setModal(true)
  }

  const deleteConfirm = (id) => {
    Modal.confirm({
      title: 'Do you Want to delete this item?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone',
      onOk: async () => {
        await productCategoryAPI.remove(id)
        message.success('Delete success')
        fetchData({ current: 1, pageSize: 10 })
      },
    });
  }
  const fetchData = async (pagination, filters) => {
    setloading(true)
    const params = {
      ...filters,
      page: pagination.current,
      limit: pagination.pageSize,
    }

    const res = await productCategoryAPI.getAllPaginate(params)
    setProductCategory({
      data: res.data.productCategory.items,
      selected: null,
    })
    setPagination({
      current: pagination.current,
      pageSize: pagination.pageSize,
      total: res.data.productCategory.meta.totalItems
    })
    setloading(false)
  }

  const submitFilter = (value) => {
    fetchData({ current: 1, pageSize: 10 }, value)
  }

  return (
    <div>
      <Typography.Title level={2}>Product Category Management</Typography.Title>
      <Card>
        <Row justify='space-between'>
          <Col md={18}>
            <Form onFinish={submitFilter} layout='inline'>
              <Form.Item
                name="search"
                required
              >
                <Input placeholder='Cari data..' suffix={<SearchOutlined />} addonBefore={
                  <Select defaultValue="name">
                    <Select.Option value="name">Product Category Name</Select.Option>
                  </Select>
                } />
              </Form.Item>


              <Button htmlType='submit' type='primary'>Search</Button>
            </Form>
          </Col>

          <Button onClick={() => setModal(true)} type='primary' >Add Product Category</Button>
        </Row>

      </Card>
      <Spacer />
      <Card>
        <Table
          columns={tableColumns}
          pagination={pagination}
          onChange={(pagination, filter, sorter) => fetchData(pagination)}
          dataSource={productCategory.data}
          loading={loading}
          rowKey='id' scroll={{ x: true }}
        />
      </Card>

      <ProductCategoryFormModal
        visible={modal}
        data={productCategory.selected}
        onCancel={() => {
          setModal(false)
          setProductCategory({ ...productCategory, selected: null })
        }}
        onFinish={() => {
          setProductCategory({ ...productCategory, selected: null })
          setModal(false)
          fetchData(pagination)
        }}
        warehouseId={routeParams.warehouseId}
      />
    </div>
  )
}
export default ProductCategoryPage